<template>
  <div class="links">
    <ul class="list">
      <li class="item">
         <span>{{ section.label }}</span>
      </li>
      <router-link tag="li" :to="promo.link" v-for="(promo, key) in section.promos" class="item link">
        <div v-if="styleObject" class="background" :style="styleObject(key)"></div>
        <span>{{ promo.label }}</span>
      </router-link>
    </ul>
  </div>
</template>

<script>
import completeLoad from '../mixins/completeLoad'
import $ from 'jquery'

export default {
  props: [
    'section',
    'hover'
  ],

  data() {
    return {
      key: null
    }
  },

  mixins: [completeLoad],

  mounted () {
    // this.$nextTick(function () {
    //   $(this.$el).find('.list .link').each(function () {
    //     var background = $(this).find('.background')

    //     $(this).mousemove(function (e) {
    //       var x = (e.offsetX * 100 / $(this).width())//- ((e.offsetX / 100) * 10)
    //       var y = (e.offsetY * 100 / $(this).height()) //- ((e.offsetY / 100) * 10)
    //       background.css("background-position", x + "% " + y + "%");
    //     })
    //   })
    // })
  },

  methods: {
    styleObject(key) {
      if (this.section.promos[key].image) {
        return {
          'background-image': 'url(' + this.section.promos[key].image + ')'
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss">
.links {
  .list {
    width: 100%;
    padding: 0px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .item {
      width: 100%;
      border-bottom: 1px solid white;
      height: 100%;
      position: relative;
      align-self: center;
      margin: 0px;
      display: flex;
      align-items: center;
      padding: 0px 30px;
      &:last-child {
        border-bottom: 0px;
      }

      .background {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        opacity: 0;
        transition: all 1s ease;
        @media (max-width: 1024px) {
          opacity: 1;
        }
      }

      span {
        width: 90%;
        z-index: 1;
      }

      &.link {
        cursor: pointer;
        box-shadow: none;
        z-index: 0;
      //  transform: scale(1);
        position: relative;
        
        &:hover {
          box-shadow: rgba(0, 0, 0, 0.25) 2px 1px 20px;
          .background {
            opacity: 1;
          }
        //  transform: scale(1.03);
       //   border-bottom: 0px solid transparent;
       //   z-index: 160;
      //    .unit-glass {
          //   background: rgba(0, 0, 0, 0);
          // }
        // }
        // &:hover {
        //   background-color: rgba(0, 0, 0, 0.35);
        }
      }
    }
  }
}
</style>